/* DialogContainer CSS Module */

.container {
  /* CSS Variables for position variants */
  --vapor-dialog-container-align-items: center;
  --vapor-dialog-container-vertical-padding: var(--spaces-16);

  /* Base styles */
  align-items: var(--vapor-dialog-container-align-items);
  contain: strict;
  display: grid;
  height: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  justify-items: center;
  overflow-y: auto;
  padding-block-end: var(--vapor-dialog-container-vertical-padding);
  padding-block-start: var(--vapor-dialog-container-vertical-padding);
  padding-inline-end: var(--vapor-dialog-padding-inline-end);
  padding-inline-start: var(--vapor-dialog-padding-inline-start);
  position: fixed;
  width: 100%;
  z-index: var(--vapor-dialog-z-index);

  /* Scrollbar styles */
  -ms-overflow-style: -ms-autohiding-scrollbar;
  -webkit-overflow-scrolling: touch;

  @supports (scrollbar-width: auto) {
    scrollbar-gutter: stable;
    scrollbar-color: var(--colors-border-tertiary-stark) transparent;
    scrollbar-width: auto;
  }

  /* Position: top */
  &:where([data-position='top']) {
    --vapor-dialog-container-align-items: start;
    --vapor-dialog-container-vertical-padding: 10vh;
  }

  /* Small viewport height override - center regardless of position */
  @media (max-height: 400px) {
    --vapor-dialog-container-align-items: center;
    --vapor-dialog-container-vertical-padding: var(--spaces-16);
  }

  /* Desktop position: top - remove bottom padding */
  @media (min-width: 1280px) {
    &:where([data-position='top']) {
      padding-block-end: 0;
    }
  }

  /* Mobile fullscreen variant */
  &:where([data-mobile-variant='fullscreen']) {
    /* 767px is our Tablet breakpoint width minus 1px */
    @media (max-width: 767px) {
      --vapor-dialog-container-vertical-padding: 0px;
      padding-left: max(0px, env(safe-area-inset-left));
      padding-right: max(0px, env(safe-area-inset-right));
    }

    @media (min-width: 768px) {
      justify-items: center;
    }
  }
}

